import React, {useReducer} from 'react'

import {RouterContext, State} from './RouterContext'

type Props = {
  defaultPath: string
}

type Action = {type: 'push'; payload: string} | {type: 'replace'; payload: string}

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'push': {
      const [tab] = state

      return [tab, action.payload]
    }
    case 'replace': {
      return action.payload.split('/') as State
    }
  }

  return state
}

// для такой примитивнрой вещи тащить целиком react-router-dom не очень хочется
// но на всякий случай имена оставил такими же
const Router: React.FC<React.PropsWithChildren<Props>> = ({children, defaultPath}) => {
  const store = useReducer(reducer, [defaultPath])

  return <RouterContext.Provider children={children} value={store} />
}

export default Router
